import _ from "lodash";

const filterScenariosByConstraints = (
  scenarioList,
  referenceScenario,
  constraints
) => {
  return _.partition(scenarioList, (scenario) => {
    if (
      scenario.min_price_change * 100 < constraints.priceRange[0] ||
      scenario.max_price_change * 100 > constraints.priceRange[1]
    )
      return false;

    if (
      scenario.roi < constraints.roiRange[0] ||
      scenario.roi > constraints.roiRange[1]
    )
      return false;

    if (
      constraints.totalInvestmentIn &&
      scenario.investment_in - referenceScenario.investment_in >
        constraints.totalInvestmentIn
    ) {
      return false;
    }

    if (
      constraints.totalInvestment &&
      scenario.investment - referenceScenario.investment >
        constraints.totalInvestment
    ) {
      return false;
    }

    const pctUnits =
      (100 * (scenario.units - referenceScenario.units)) /
      referenceScenario.units;

    if (
      pctUnits < constraints.unitsRange[0] ||
      pctUnits > constraints.unitsRange[1]
    )
      return false;

    const pctMargin =
      (100 * (scenario.margin - referenceScenario.margin)) /
      referenceScenario.margin;

    if (
      pctMargin < constraints.marginRange[0] ||
      pctMargin > constraints.marginRange[1]
    )
      return false;

    return true;
  });
};

export const filterScenariosByConstraintsOld = (
  scenarioList,
  referenceScenario,
  constraints
) => {
  return _.partition(scenarioList, (scenario) => {
    if (
      scenario.min_price_change * 100 <= constraints.priceRange[0] ||
      scenario.max_price_change * 100 >= constraints.priceRange[1]
    )
      return false;

    if (
      constraints.totalInvestmentIn &&
      scenario.investment_in - referenceScenario.investment_in >
        constraints.totalInvestmentIn
    ) {
      return false;
    }

    if (
      constraints.totalInvestment &&
      scenario.investment - referenceScenario.investment >
        constraints.totalInvestment
    ) {
      return false;
    }

    const pctUnits =
      (100 * (scenario.units - referenceScenario.units)) /
      referenceScenario.units;

    if (
      pctUnits < constraints.unitsRange[0] ||
      pctUnits > constraints.unitsRange[1]
    )
      return false;

    const pctMargin =
      (100 * (scenario.margin - referenceScenario.margin)) /
      referenceScenario.margin;

    if (
      pctMargin < constraints.marginRange[0] ||
      pctMargin > constraints.marginRange[1]
    )
      return false;

    return true;
  });
};

export default filterScenariosByConstraints;
